import Http from '@/utils/httpRequest'

const axios = new Http()
export default {
  getNoticeList: data => {
    return axios.post('/applet/notice/public/list', data)
  },
  getNoticeDetail: data => {
    return axios.get('/applet/notice/public/getInfoById', data)
  },
  getWorkGuideList: data => {
    return axios.post('/applet/workGuide/public/list', data)
  },
  getWorkGuideDetail: data => {
    return axios.get('/applet/workGuide/public/getInfoById', data)
  },
  getPoliciesList: data => {
    return axios.post('/applet/policies/public/list', data)
  },
  getPoliciesDetail: data => {
    return axios.get('/applet/policies/public/getInfoById', data)
  }
}
